import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseErrorModalReturn } from '@percent/domain/giving'

export type UnpublishCampaignFailureModalProps = Pick<UseErrorModalReturn, 'isOpen' | 'errorMsg' | 'closeModal'>

export function UnpublishCampaignFailureModal({ isOpen, errorMsg, closeModal }: UnpublishCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="unpublish-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('workplace_giving.myCampaigns.actions.unpublishErrorModal.title')}
        description={errorMsg}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
      />
    </Modal>
  )
}
